import { useTranslation } from "react-i18next";
import SearchIcon from "../../../../icons/searchIcon";
import Select from "../../../../components/select/select";
import DataTable from "../../../../components/table/dataTable";
import EyeIcon from "../../../../icons/eyeIcon";
import Paginate from "../../../../components/pagination/paginate";
import DateInput from "../../../../components/inputs/dateInput";
import { useState } from "react";
import Popup from "../../../../components/popups/popup";
import DotIcon from "../../../../icons/dotIcon";
import CheckIcon from "../../../../icons/checkIcon";
import { primaryColor } from "../../../../utils";

const ShipmentTracking = () => {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);

  const deliveryStatusOptions = [
    { label: t("all"), value: "all" },
    { label: t("delivered"), value: "delivered" },
    { label: t("inPort"), value: "in_port" },
    { label: t("shippingInProgress"), value: "shipping_in_progress" },
  ];

  const shipmentType = [
    { label: t("all"), value: "all" },
    { label: t("normal"), value: "normal" },
    { label: t("fast"), value: "fast" },
  ];

  const tableHead = [
    { header: t("shipmentNumber"), accessorKey: "shipmentNumber" },
    { header: t("customerName"), accessorKey: "customerName" },
    { header: t("shipmentDate"), accessorKey: "shipmentDate" },
    { header: t("destination"), accessorKey: "destination" },
    { header: t("currentStatus"), accessorKey: "currentStatus" },
    { header: t("type"), accessorKey: "type" },
    { header: t("actions"), accessorKey: "actions" },
  ];

  const shipmentData = [
    {
      shipmentNumber: "ORDER1001",
      customerName: "علي ياسر",
      shipmentDate: "27/07/2024",
      destination: "باريس",
      currentStatus: "تم التسليم",
      type: "عادي",
      actions: "تفاصيل",
    },
    {
      shipmentNumber: "ORDER1002",
      customerName: "محمد أحمد",
      shipmentDate: "28/07/2024",
      destination: "لندن",
      currentStatus: "جاري الشحن",
      type: "سريع",
      actions: "تتبع",
    },
    {
      shipmentNumber: "ORDER1003",
      customerName: "سارة خالد",
      shipmentDate: "29/07/2024",
      destination: "اسطنبول",
      currentStatus: "في الميناء",
      type: "عادي",
      actions: "إلغاء",
    },
    {
      shipmentNumber: "ORDER1004",
      customerName: "نورا عبدالله",
      shipmentDate: "30/07/2024",
      destination: "دبي",
      currentStatus: "متأخر",
      type: "سريع",
      actions: "تعديل",
    },
  ];

  const shipmentStatus = [
    { status: t("receivedFromCustomer"), done: true },
    { status: t("prepared"), done: true },
    { status: t("outOfTheBranch"), done: true },
    { status: t("shipping"), done: false },
    { status: t("delivered"), done: false },
  ];

  const tableData = shipmentData.map((d) => {
    const destination = (
      <span className="font-medium" style={{ color: primaryColor }}>
        {d.destination}
      </span>
    );
    const currentStatus = (
      <span className="py-2 w-[100px] block mx-auto rounded-lg bg-[#E6F4EF] dark:bg-[#1f2e2c]">
        {d.currentStatus}
      </span>
    );
    const actions = (
      <div className="flex items-center justify-center gap-2">
        <span
          onClick={() => {
            setShow(true);
            setSelected(d);
          }}
        >
          <EyeIcon className="cursor-pointer" />
        </span>
      </div>
    );

    return {
      shipmentNumber: d.shipmentNumber,
      customerName: d.customerName,
      shipmentDate: d.shipmentDate,
      destination,
      currentStatus,
      type: d.type,
      actions,
    };
  });

  const data = { last_page: 20 };
  const handlePagination = () => {};

  return (
    <div className="min-w-full p-5 capitalize bg-white dark:bg-gray-900 rounded-2xl">
      <section className="flex border-b border-b-[#888888] pb-2 flex-wrap items-center justify-between">
        <div className="font-medium text-black dark:text-white">
          {t("assignedShipments")}
        </div>
        <div className="flex border border-[#F9F9F9] dark:border-gray-700 focus-within:border-black dark:focus-within:border-white items-center gap-4 bg-[#F9F9F9] dark:bg-gray-800 rounded-full px-4">
          <SearchIcon />
          <input
            type="text"
            className="flex-1 py-2 bg-transparent min-w-[400px] focus:border-none focus-visible:outline-none text-black dark:text-white"
            placeholder={t("shipmentNumber/customerName")}
          />
        </div>
        <div className="flex justify-center gap-1">
          <Select options={deliveryStatusOptions} placeholder={t("shipmentStatus")} />
          <Select options={shipmentType} placeholder={t("shipmentType")} />
          <div>
            <DateInput />
          </div>
        </div>
      </section>

      <div className="min-w-full my-5 overflow-x-auto">
        <DataTable TableHead={tableHead} TableData={tableData} />
      </div>

      <Popup state={show} setState={setShow} header={t("shipmentDetails")}>
        <section className="max-h-[600px] overflow-auto">
          <section className="space-y-4">
            <div>
              <div className="flex items-center justify-between gap-4">
                <p>
                  <span className="text-xs text-mainGray dark:text-gray-300">
                    {t("shipmentNumber")}{" "}
                  </span>
                  <span className="text-sm font-medium text-black dark:text-white">
                    {selected?.shipmentNumber}
                  </span>
                </p>
              </div>
              <div className="p-4 rounded-lg bg-[#F2F4F6] dark:bg-gray-800">
                <p className="flex items-center gap-5">
                  <span className="text-xs text-mainGray dark:text-gray-300">
                    {t("customer")}:
                  </span>
                  <span className="text-sm font-medium text-black dark:text-white">
                    {selected?.customerName}
                  </span>
                </p>
                <p className="flex items-center gap-5">
                  <span className="text-xs text-mainGray dark:text-gray-300">
                    {t("address")}:
                  </span>
                  <span className="text-sm font-medium text-black dark:text-white">
                    الرياض، المملكة العربية السعودية
                  </span>
                </p>
                <p className="flex items-center gap-5">
                  <span className="text-xs text-mainGray dark:text-gray-300">
                    {t("weight")}:
                  </span>
                  <span className="text-sm font-medium text-black dark:text-white">
                    3.5 كجم
                  </span>
                </p>
                <p className="flex items-center gap-5">
                  <span className="text-xs text-mainGray dark:text-gray-300">
                    {t("type")}:
                  </span>
                  <span className="text-sm font-medium text-black dark:text-white">
                    {selected?.type}
                  </span>
                </p>
                <p className="flex items-center gap-5">
                  <span className="text-xs text-mainGray dark:text-gray-300">
                    {t("currentStatus")}:
                  </span>
                  <span className="text-sm font-medium text-black dark:text-white">
                    {selected?.currentStatus}
                  </span>
                </p>
                <p className="flex items-center gap-5">
                  <span className="text-xs text-mainGray dark:text-gray-300">
                    {t("shipmentDate")}:
                  </span>
                  <span className="text-sm font-medium text-black dark:text-white">
                    {selected?.shipmentDate}
                  </span>
                </p>
                <p className="flex items-center gap-5">
                  <span className="text-xs text-mainGray dark:text-gray-300">
                    {t("expectedDeliveryDate")}:
                  </span>
                  <span className="text-sm font-medium text-black dark:text-white">
                    29/5/2025
                  </span>
                </p>
              </div>
            </div>
          </section>

          <section className="w-[300px] my-4">
            <div>
              <h5 className="font-medium text-black capitalize dark:text-white">
                {t("shipmentStatus")}
              </h5>
              <div className="p-4">
                {shipmentStatus.map((step, idx) => (
                  <div key={idx} className="flex items-start gap-2 text-right">
                    <div className="flex flex-col items-center px-1 pt-1">
                      {step.done ? (
                        <span className="size-8 bg-[#22C55E] rounded-full flex items-center justify-center">
                          <CheckIcon fill={"white"} />
                        </span>
                      ) : (
                        <span className="size-8 bg-[#D1D5DB] rounded-full flex items-center justify-center">
                          <DotIcon />
                        </span>
                      )}
                      {idx < shipmentStatus.length - 1 && (
                        <div className="w-[2px] h-6 bg-gray-300 mt-1 dark:bg-gray-600"></div>
                      )}
                    </div>

                    <div className="flex flex-col text-sm mt-[10px] text-black dark:text-white">
                      <span className="font-medium">{step.status}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </section>
      </Popup>

      <Paginate handlePagination={handlePagination} data={data} />
    </div>
  );
};

export default ShipmentTracking;
